import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { environment } from 'src/environments/environment';
import { PAGE_SIZE, MAX_SIZE } from 'src/app/onelog/common/config/common';
import { PIPELINE } from 'src/app/onelog/common/config/url';
import { DateSelectComponent } from 'src/app/onelog/common/fields/date-select/date-select.component';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';

@Component({
  selector: 'app-pipeline-info',
  templateUrl: './pipeline-info.component.html',
  styleUrls: ['./pipeline-info.component.css'],
})
export class PipelineInfoComponent implements OnInit {
  @ViewChildren(DateSelectComponent) NgbDate: QueryList<DateSelectComponent>;

  constructor(
    private _requestService: RequestService,
    private productStatus: ProductSatusService
  ) {}

  selectedproductId: string = '';
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  selectStarFilterDate: any = [];
  selectEndFilterDate: any = [];
  successToastShow: boolean = false;
  productStatusList: any = [];
  DefaultselectedStatus: string = '';
  selectedStatus: string = '';
  selectedBookType: string = '';
  dropdownListBookStatus: any = [];
  listBookType: any = [];
  isDerivative: boolean = false;
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;

  ngOnInit(): void {
    this.loadProducts(this.createPostData());
    this.loadProductStatusList();
    this.listBookType = ['Normal', 'Mini', 'Maxi', 'Licensed'];

    // this.dropdownListBookType = NEW_DROP_DOWN_LIST_BOOK_TYPE;
  }

  loadProducts(postData: any = [], url: string = PIPELINE) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
        }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        //this.currentPage = this.responseData.current_page;
        console.log(this.products);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  loadProductStatusList() {
    return this.productStatus.getStatusList().subscribe((data: {}) => {
      this.productStatusList = data;
      let statusList: any = [];
      this.productStatusList.data.forEach(function (currentValue: any) {
        statusList.push(currentValue.attributes.name);
      });

      this.dropdownListBookStatus = statusList;
    });
  }

  createPostData() {
    return {
      status: this.selectedStatus,
      type: this.selectedBookType,
      productID: this.selectedproductId,
      derivative: this.isDerivative,
      page: this.currentPage,
    };
  }

  updateSelectedType(event: any) {
    //console.log(event);

    if (event.name == 'status') {
      this.selectedStatus = event.selectedOption;
    }
    if (event.name == 'bookType') {
      this.selectedBookType = event.selectedOption;
    }
    console.log(this.selectedStatus, this.selectedBookType);
  }

  downloadReport() {
    this._requestService.download(
      PIPELINE,
      {
        is_download: 1,
        status: this.selectedStatus,
        type: this.selectedBookType,
        productID: this.selectedproductId,
        derivative: this.isDerivative,
        page: this.currentPage,
      },
      '',
      'pipeline_info'
    );
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      status: this.selectedStatus,
      type: this.selectedBookType,
      productID: this.selectedproductId,
      derivative: this.isDerivative,
      page: this.currentPage,
    });

    this.loadProducts(this.createPostData());
    this.searchBtnText = 'Search';
    this.showSearchLoading = false;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    (this.selectedStatus = ''),
      (this.selectedBookType = ''),
      (this.selectedproductId = ''),
      (this.isDerivative = false),
      this.clearAllDropDowns();
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      DropDownComp.clearInput();
    });
  }

  assignTotalValue(value: any) {
    this.totalProducts = value;
  }
}
